const TextArea = (props)=>{
    return (
        <div className="col-span-full sm:col-auto">
            <textarea
                className={`border border-edit_input_border px-3 pt-1.5 ${
                    props.disabled !== undefined || props.disabled
                        ? "bg-[#e9e9e9] cursor-not-allowed dark:bg-[#b5b5b5] text-edit_input_text_disabled"
                        : "bg-white dark:bg-[#ffffffdd] text-edit_input_text"
                } rounded-[4px] px-2 w-full dark:text-[#555555]`}
                onChange={props.onchange}
                onBlur={props.onblur}
                value={props.value}
                rows={"4"}
                disabled={props.disabled}
            ></textarea>
            <div className="mt-[2px] text-[.8rem] text-edit_input_validation">
                {props.children}
            </div>
        </div>
    )
}

export default TextArea